export default __webpack_public_path__ + "static/media/icone-tarif-bleu.dd190a24.svg";